import { ITEMS_CHUNK_SIZE } from "../../constants";
export var recalculatePagination = function (pagination) {
    if (pagination === void 0) { pagination = {}; }
    var loadedItems = (pagination.top || 0) + (pagination.skip || 0);
    return {
        top: pagination.top || ITEMS_CHUNK_SIZE,
        skip: loadedItems
    };
};
//# sourceMappingURL=recalculatePagination.js.map